// import COS from 'cos-js-sdk-v5';
import { get } from './get';

async function initCOS() {
    try {
        const [res, { default: COS }] = await Promise.all([
            getEnctyptToken(),
            import(/* webpackChunkName: "cos-js-sdk-v5" */ 'cos-js-sdk-v5'),
        ]);
        if (res.code !== 200) {
            throw new Error(res);
        }
        const { token } = res.data;
        const { credentials, startTime, expiredTime } = JSON.parse(token);
        return new COS({
            getAuthorization: async function (options, callback) {
                callback({
                    TmpSecretId: credentials.tmpSecretId,
                    TmpSecretKey: credentials.tmpSecretKey,
                    SecurityToken: credentials.sessionToken,
                    // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
                    StartTime: startTime, // 时间戳，单位秒，如：1580000000
                    ExpiredTime: expiredTime, // 时间戳，单位秒，如：1580000000
                });
            },
        });
    } catch (error) {
        console.info('initCOS', error.message, error);
        throw error;
    }
}

function putCOS(cos, blob, key) {
    return new Promise((resolve, reject) => {
        if (!cos || !blob || !key) reject(new Error('putCOS 缺少参数'));
        cos.putObject(
            {
                Bucket: 'kk-cbb-share-1253543992' /* 填入您自己的存储桶，必须字段 */,
                Region: 'ap-shanghai' /* 存储桶所在地域，例如ap-beijing，必须字段 */,
                Key: key /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */,
                Body: blob,
            },
            function (err, data) {
                console.info(err || data);
                if (err) {
                    reject(new Error('图片上传失败#0'));
                }
                resolve(data);
            }
        );
    });
}

function getEnctyptToken() {
    return get({
        url: `${process.env.VUE_APP_COS_API}/v1/share/tools/img/enctypt_token`,
    });
}

function getEnctyptImgUrl(imgUrl) {
    return get({
        url: `${process.env.VUE_APP_COS_API}/v1/share/tools/img/enctypt_img_url`,
        data: {
            img_url: imgUrl,
        },
    });
}

export const COSUtil = {
    putCOS,
    initCOS,
    getEnctyptImgUrl,
};
